{
  "common": {
    "skipToContent": "Aller au contenu principal",
    "footer": {
      "copyright": "PAC Hub © 2024–{{year}}. Tous droits réservés.",
      "followX": "Suivez-nous sur X",
      "followLinkedIn": "Suivez-nous sur LinkedIn"
    }
  },
  "marketing": {
    "nav": {
      "home": "Accueil",
      "features": "Fonctionnalités",
      "about": "À propos",
      "howItWorks": "Comment ça marche",
      "guides": "Guides",
      "faq": "FAQ",
      "contact": "Contact",
      "menuToggle": "Ouvrir le menu de navigation"
    },
    "languageSwitcher": {
      "label": "Langue",
      "en": "English",
      "fr": "Français",
      "zh": "中文 (简体)"
    },
    "meta": {
      "home": {
        "title": "PAC Hub | Une connexion. Une communauté de parents.",
        "description": "Une connexion. Une communauté de parents. PAC Hub est la plateforme tout-en-un et sécurisée pour les conseils consultatifs de parents."
      },
      "features": {
        "title": "Fonctionnalités | PAC Hub",
        "description": "Une plateforme unifiée pour les conseils consultatifs de parents : calendrier, bénévoles, repas chauds et plus encore sur le site de votre école, avec une seule connexion parentale."
      },
      "howItWorks": {
        "title": "Comment ça marche | PAC Hub",
        "description": "Configuration rapide pour votre conseil consultatif de parents sur votreecole.pachub.ca : site d'école, inscription des parents et rôles qui correspondent à la façon dont les conseils fonctionnent."
      },
      "guides": {
        "title": "Guides | PAC Hub",
        "description": "Courtes démonstrations pour vous connecter et utiliser PAC Hub."
      },
      "guide": {
        "title": "{{title}} | PAC Hub",
        "description": "Une courte démonstration PAC Hub. {{title}}."
      },
      "about": {
        "title": "À propos de PAC Hub",
        "description": "Conçu par des conseils pour des conseils. Logiciel de propriété canadienne pour les conseils consultatifs de parents."
      },
      "faq": {
        "title": "FAQ | PAC Hub",
        "description": "Réponses aux questions courantes sur PAC Hub pour les conseils consultatifs de parents."
      },
      "contact": {
        "title": "Contactez PAC Hub",
        "description": "Contactez PAC Hub pour les écoles pilotes et une plateforme unifiée pour votre conseil consultatif de parents."
      },
      "privacy": {
        "title": "Politique de confidentialité | PAC Hub",
        "description": "Comment PAC Hub recueille, utilise et protège les renseignements soumis par l'entremise de notre site Web marketing."
      },
      "notFound": {
        "title": "Page introuvable | PAC Hub"
      }
    },
    "jsonLd": {
      "organizationDescription": "Une connexion. Une communauté de parents. PAC Hub est la plateforme tout-en-un et sécurisée pour les conseils consultatifs de parents."
    },
    "notFound": {
      "title": "Page introuvable",
      "description": "Cette page n'est pas disponible sur le site marketing de PAC Hub.",
      "returnHome": "Retour à l'accueil"
    },
    "footer": {
      "privacyPolicy": "Politique de confidentialité",
      "about": "À propos",
      "guides": "Guides",
      "faq": "FAQ"
    },
    "hero": {
      "title": "Une connexion.\nUne communauté de parents.",
      "tagline": "La plateforme tout-en-un pour les conseils consultatifs de parents. Sûre, sécurisée et conçue pour votre communauté scolaire.",
      "primaryCta": "Voir ce qui est inclus",
      "secondaryCta": "Devenir une école pilote"
    },
    "home": {
      "pillarsTitle": "Pourquoi PAC Hub fonctionne",
      "pillarsDescription": "Une plateforme unifiée pour les conseils consultatifs de parents. Un seul endroit pour que votre communauté scolaire accède à tous vos outils.",
      "pillarAllInOneTitle": "Tout-en-un pour les parents",
      "pillarAllInOneDescription": "Les parents se connectent une seule fois sur le site PAC Hub de votre école au lieu de créer un compte distinct pour chaque outil utilisé par votre conseil.",
      "pillarOnePlaceTitle": "Un seul endroit à consulter",
      "pillarOnePlaceDescription": "Événements, inscription des bénévoles, repas chauds, messages et formulaires sur le même site scolaire à chaque fois, pour que les parents passent moins de temps à chercher des liens.",
      "pillarTrustTitle": "Sûr, sécurisé, à vous",
      "pillarTrustDescription": "Authentification moderne, données limitées à l'école et une promesse claire : nous ne vendons pas les coordonnées de votre communauté parentale à des tiers.",
      "howItWorksTeaserTitle": "Comment ça marche",
      "howItWorksTeaserDescription": "Votre conseil obtient un site d'école. Les familles s'inscrivent une fois. Tout le monde gère l'année au même endroit.",
      "howItWorksTeaserCta": "Voir comment ça marche",
      "steps": {
        "schoolSite": {
          "title": "Votre école obtient un site",
          "description": "Votre conseil consultatif de parents est sur votreecole.pachub.ca, avec le nom de votre conseil sur le sous-domaine de votre école."
        },
        "register": {
          "title": "Les familles s'inscrivent une fois",
          "description": "Les parents s'inscrivent avec un code d'école, vérifient leur courriel et lient les enfants aux classes."
        },
        "runYear": {
          "title": "Gérez l'année au même endroit",
          "description": "Repas chauds, événements, messages, réunions et plus, avec la même connexion, toute l'année."
        }
      },
      "includedTitle": "Ce qui est inclus",
      "includedDescription": "Tout ce dont votre conseil a besoin, au même endroit.",
      "includedItems": {
        "hotLunch": "Repas chauds",
        "volunteers": "Bénévoles",
        "budget": "Budget",
        "communications": "Communications",
        "meetings": "Réunions",
        "fundraising": "Collecte de fonds"
      },
      "includedLearnMore": "En savoir plus",
      "trustTitle": "La confiance par conception",
      "pilotCtaTitle": "Prêt à simplifier votre conseil ?",
      "pilotCtaDescription": "Nous accueillons des écoles pilotes. Parlez-nous de votre conseil et nous vous expliquerons comment PAC Hub peut servir votre communauté.",
      "pilotCtaButton": "Nous joindre"
    },
    "featuresPage": {
      "metaTitle": "Fonctionnalités | PAC Hub",
      "metaDescription": "Une plateforme unifiée pour les conseils consultatifs de parents : calendrier, bénévoles, repas chauds et plus encore sur le site de votre école, avec une seule connexion parentale.",
      "heroTitle": "Tout ce dont votre conseil a besoin",
      "heroDescription": "Un site d'école. Une connexion parentale. Des outils conçus pour les conseils consultatifs de parents.",
      "pilotCtaTitle": "Prêt à simplifier votre conseil ?",
      "pilotCtaDescription": "Nous accueillons des écoles pilotes. Parlez-nous de votre conseil et nous vous expliquerons comment PAC Hub peut servir votre communauté.",
      "pilotCtaButton": "Nous joindre"
    },
    "featureDomains": {
      "hotLunch": {
        "title": "Repas chauds",
        "pitch": "Commande de repas chauds conçue pour votre site scolaire, incluse dans votre abonnement.",
        "bullets": [
          "Commandez pour chaque enfant sur un seul écran. Panier multi-dates et un seul paiement.",
          "Échéances par jour, notes d'allergie au moment de la commande et profils familiaux liés aux classes",
          "Bons de travail pour les fournisseurs, listes de distribution par classe et export d'étiquettes pour les coordonnateurs",
          "Extras du conseil pour couvrir des repas discrètement, sans mention de charité sur les listes de classe",
          "Paiement sécurisé sur votre site scolaire. Les repas chauds sont au cœur du hub, pas un ajout."
        ]
      },
      "calendar": {
        "title": "Calendrier et événements",
        "pitch": "Publiez le calendrier communautaire de votre conseil et planifiez les activités sur votre site scolaire.",
        "bullets": [
          "Créez et publiez des activités du conseil en présentiel, virtuelles ou hybrides",
          "Visibilité optionnelle du calendrier et widgets du tableau de bord pour les parents",
          "Joignez des documents de votre bibliothèque du conseil aux événements",
          "Conçu pour les carnavals, ventes de pâtisseries, bingo et réunions du conseil, pas les sorties scolaires"
        ]
      },
      "volunteers": {
        "title": "Inscription des bénévoles",
        "pitch": "Gérez l'inscription des bénévoles par créneaux sur votre site scolaire, sans compte de planification distinct pour les parents.",
        "bullets": [
          "Créneaux de bénévoles avec date, heure, capacité et sections",
          "Listes d'attente, vues de couverture et listes pour les administrateurs du conseil",
          "Liste de bénévolat des parents sur votre sous-domaine scolaire",
          "Codes QR et liens courts internes vers les flux d'inscription, avec statistiques de scans que vous contrôlez"
        ]
      },
      "communications": {
        "title": "Communications",
        "pitch": "Joignez les parents sur votre sous-domaine sans emprunter l'administration scolaire pour les courriels et les bulletins.",
        "bullets": [
          "Boîte de réception interne sur votreecole.pachub.ca avec courriel optionnel du même contenu",
          "Rédigez, publiez et ciblez les messages par rôle. Les bulletins sont des messages plus courriel.",
          "Pages de site permanentes pour À propos, politiques et contact, à côté des mises à jour ponctuelles",
          "Formulaires et permissions pour les ententes sans envoyer les parents vers un autre créateur de formulaires",
          "Sondages et participation de la communauté. Rappels SMS optionnels quand votre conseil le souhaite."
        ]
      },
      "meetings": {
        "title": "Réunions du conseil",
        "pitch": "Options vidéo internes et hybrides conçues pour les séances générales et exécutives du conseil.",
        "bullets": [
          "Salles vidéo pour les réunions du conseil sur votre site scolaire, pas des liens Zoom publics",
          "Compatible hybride avec lieu en personne quand votre conseil en a besoin",
          "Élections et scrutins conçus pour les flux de gouvernance du conseil",
          "Les parents participent avec la même connexion que pour les repas et le bénévolat"
        ]
      },
      "documents": {
        "title": "Documents du conseil",
        "pitch": "Dossiers de gouvernance et archives qui survivent au changement de dirigeants.",
        "bullets": [
          "Rédigez des ordres du jour structurés en dossiers PDF à votre image et joignez les versions finales aux événements de réunion",
          "Procès-verbaux et archives de gouvernance organisés par année scolaire",
          "Les parents reçoivent les documents de réunion sur votre site scolaire",
          "Les dossiers finalisés restent avec l'événement, pas dispersés dans les boîtes de réception"
        ]
      },
      "schoolYear": {
        "title": "Année scolaire, familles et membres",
        "pitch": "Configurez l'année, liez les enfants aux classes et gérez les rôles comme les conseils fonctionnent vraiment.",
        "bullets": [
          "Activez et archivez les années scolaires. Copiez les classes vers la nouvelle année.",
          "Profils des enfants et familles avec choix de classe et notes d'allergie ou régime",
          "Liste de membres consultable, invitations, modification des rôles et attribution du coordonnateur des repas chauds",
          "Transfert de responsabilité quand les dirigeants changent, avec désactivation d'année pour les parents",
          "Tableau de bord pour les parents : messages non lus, créneaux, fenêtres de repas chauds ouverts et ce qui demande attention"
        ]
      },
      "fundraising": {
        "title": "Collecte de fonds et dons",
        "pitch": "Suivez les campagnes et les dons sur le site de votre conseil, pas dans un portail séparé.",
        "bullets": [
          "Campagnes de collecte de fonds avec objectifs et suivi des progrès",
          "Registres de dons et reçus fiscaux lorsque votre statut de charité le permet",
          "Paiement distinct des repas chauds avec traitement sécurisé sur votre site scolaire",
          "Progrès des campagnes que vos trésoriers peuvent mettre à jour et partager avec le conseil"
        ]
      },
      "budget": {
        "title": "Budget et outils du trésorier",
        "pitch": "Rapports budget vs réel et séparation des fonds pour les trésoriers et vérificateurs.",
        "bullets": [
          "Vues budget vs réel pour les rapports mensuels et cumul annuel",
          "Registres séparés pour les fonds généraux et les fonds de jeux lorsque votre conseil en a besoin",
          "Exports adaptés à l'AGM et aux vérificateurs, intégrés à votre hub du conseil",
          "Listes de contrôle et registres de jeux licenciés lorsque les règles de licence de la C.-B. s'appliquent"
        ]
      },
      "trustPlatform": {
        "title": "Confiance et plateforme",
        "pitch": "Sécurité moderne et données par école, avec un abonnement qui finance la plateforme sans vendre les informations de votre communauté.",
        "bullets": [
          "Chaque école sur son propre sous-domaine avec accès par rôle pour les parents et les dirigeants",
          "Authentification moderne et comptes limités à l'école. Journal d'audit pour les actions admin sensibles.",
          "Nous ne vendons pas les données de votre communauté à des tiers. L'abonnement de votre conseil finance la plateforme.",
          "Anglais, français et chinois pour votre communauté scolaire"
        ]
      }
    },
    "about": {
      "heroTitle": "Conçu par des conseils pour des conseils",
      "heroDescription": "Les conseils consultatifs de parents fonctionnent avec trop d'outils et empruntent trop de temps au bureau scolaire déjà occupé par les opérations de l'école.",
      "problemTitle": "Le problème",
      "problemBody": "Les conseils consultatifs de parents des écoles primaires de la C.-B. fonctionnent avec une pile fragmentée : site de repas chauds, visioconférence, formulaires et sondages, tableurs, sites Web personnalisés et outils de liens courts. Connexions multiples, faible continuité quand les dirigeants changent, et travail qui retombe sur le personnel du bureau scolaire déjà concentré sur la gestion de l'école.",
      "solutionTitle": "Notre approche",
      "solutionBody": "Un site d'école, tout ce dont votre conseil a besoin au même endroit.",
      "solutionPrinciples": "Pas de publicité. Pas de vente de courriels. Vos données sont protégées.",
      "solutionTagline": "Une connexion. Une communauté de parents.",
      "founderTitle": "Qui est derrière",
      "founderBody": "PAC Hub est conçu par un président de conseil à deux mandats et ingénieur logiciel qui connaît le tableur du trésorier, la boîte du coordonnateur des repas chauds et l'appel de dernière minute pour des bénévoles. De propriété canadienne et conçu pour les écoles canadiennes, pour les conseils qui veulent un hub moderne au lieu de six favoris.",
      "ctaTitle": "Parlez avec nous",
      "ctaDescription": "Nous accueillons des écoles pilotes et partenaires de conception partout en C.-B.",
      "ctaButton": "Nous joindre"
    },
    "howItWorks": {
      "heroTitle": "Configuration rapide pour votre conseil",
      "heroDescription": "PAC Hub donne à votre conseil un seul endroit sur votreecole.pachub.ca. Voici comment les familles et les dirigeants commencent.",
      "steps": {
        "schoolSite": {
          "title": "Votre conseil obtient un site d'école",
          "description": "Votre conseil est configuré sur un sous-domaine de pachub.ca avec le nom de votre école. Les dirigeants gèrent les paramètres, les rôles et la facturation depuis le même hub que les parents."
        },
        "register": {
          "title": "Les parents s'inscrivent avec un code d'école",
          "description": "Les parents s'inscrivent sur votreecole.pachub.ca, vérifient leur courriel et lient les enfants aux classes. Des codes élevés permettent aux dirigeants du conseil et aux admins du site de s'intégrer en sécurité."
        },
        "runYear": {
          "title": "Liez les enfants et gérez l'année",
          "description": "Les parents ajoutent les enfants, choisissent les classes et utilisent une connexion pour les repas, événements, messages et bénévolat. Les dirigeants publient activités, menus et mises à jour sur le même site."
        },
        "roles": {
          "title": "Des rôles qui correspondent à la vie réelle du conseil",
          "description": "Parents, dirigeants du conseil, coordonnateurs des repas chauds et admins du site voient ce dont ils ont besoin. Votre conseil contrôle qui peut accéder aux événements, messages et listes de membres."
        }
      },
      "rolesTitle": "Qui utilise PAC Hub",
      "roles": {
        "parents": {
          "title": "Parents",
          "description": "Une connexion pour les commandes de repas, l'inscription des bénévoles, les messages et votre tableau de bord montrant ce qui demande attention."
        },
        "executives": {
          "title": "Dirigeants du conseil",
          "description": "Publiez des événements, gérez les programmes de repas chauds, envoyez des bulletins, gérez les membres et transférez la responsabilité quand les rôles changent."
        },
        "coordinators": {
          "title": "Coordonnateurs des repas chauds",
          "description": "Gérez fournisseurs, menus, échéances et exports sans devenir le responsable de la facturation ni jongler avec un compte repas chauds séparé."
        }
      },
      "ctaTitle": "Voir tout ce qui est inclus",
      "ctaButton": "Explorer les fonctionnalités",
      "pilotCtaTitle": "Devenir une école pilote",
      "pilotCtaDescription": "Parlez-nous de votre conseil et nous vous expliquerons comment PAC Hub s'intègre à votre communauté.",
      "pilotCtaButton": "Nous joindre"
    },
    "guides": {
      "heroTitle": "Guides",
      "heroDescription": "Courtes démonstrations pour vous connecter et utiliser PAC Hub.",
      "empty": "Les démonstrations apparaîtront ici au fur et à mesure de leur publication.",
      "backToGuides": "Tous les guides",
      "sections": {
        "getting-started": "Premiers pas"
      },
      "videos": {
        "sign-in": {
          "description": "Comment vous connecter au site de votre école et ouvrir votre tableau de bord."
        },
        "inbox": {
          "description": "Comment ouvrir la boîte de réception, lire un message et voir les indicateurs non lus se mettre à jour."
        }
      }
    },
    "faq": {
      "heroTitle": "Questions fréquentes",
      "heroDescription": "Réponses aux questions courantes sur PAC Hub.",
      "items": {
        "whatIsPacHub": {
          "question": "Qu'est-ce que PAC Hub ?",
          "answer": "PAC Hub est une plateforme tout-en-un pour les conseils consultatifs de parents. Votre conseil obtient un site sur votreecole.pachub.ca où les parents se connectent une fois pour les repas chauds, événements, inscription des bénévoles, messages, réunions et plus. Une connexion. Une communauté de parents."
        },
        "whoIsItFor": {
          "question": "Pour qui est PAC Hub ?",
          "answer": "Les conseils consultatifs de parents des écoles primaires et intermédiaires, surtout en C.-B., qui veulent un hub moderne au lieu d'outils séparés pour les repas, les bénévoles, les bulletins et les réunions. Parents, dirigeants, trésoriers et coordonnateurs des repas chauds ont chacun un accès adapté à leur rôle."
        },
        "pricing": {
          "question": "Comment fonctionne la tarification ?",
          "answer": "Tarification simple avec tous les outils dont votre conseil a besoin au même endroit. Contactez-nous pour les détails pilotes et la tarification."
        },
        "pilot": {
          "question": "Qu'est-ce qu'une école pilote ?",
          "answer": "Les écoles pilotes travaillent avec nous pendant le déploiement initial : flux réels du conseil, rétroaction et possibilité de façonner le produit. Les pilotes reçoivent de l'aide à l'intégration et une ligne directe avec l'équipe. Utilisez le formulaire de contact pour nous parler de votre conseil."
        },
        "hotLunchIncluded": {
          "question": "Les repas chauds sont inclus ?",
          "answer": "Oui. La commande de repas chauds est au cœur de PAC Hub et incluse dans votre abonnement, pas un supplément. Les commandes utilisent un traitement de paiement sécurisé sur votre site scolaire."
        },
        "replaceStack": {
          "question": "PAC Hub remplace nos outils actuels ?",
          "answer": "PAC Hub est conçu pour consolider la commande de repas chauds, l'inscription des bénévoles, les bulletins, les liens de réunion, les formulaires et les pages du site du conseil dans une seule connexion. Vous n'aurez pas besoin de comptes séparés pour chacun de ces flux sur votre sous-domaine scolaire."
        },
        "dataSelling": {
          "question": "Vendez-vous les données des parents ?",
          "answer": "Non. Nous ne vendons pas les coordonnées des parents ou du conseil à des tiers, et nous ne diffusons pas de publicité contre votre communauté."
        },
        "languages": {
          "question": "Quelles langues sont prises en charge ?",
          "answer": "PAC Hub prend en charge l'anglais, le français et le chinois (simplifié) pour les communautés scolaires. D'autres langues à venir."
        },
        "schoolAdmin": {
          "question": "Le bureau scolaire doit gérer PAC Hub ?",
          "answer": "Non. PAC Hub permet au conseil de gérer ses propres communications, bulletins et contenu de site. Le personnel scolaire peut avoir des rôles appropriés si nécessaire, mais l'objectif est de réduire le temps et les ressources empruntés au personnel du bureau scolaire déjà concentré sur la gestion de l'école."
        },
        "ownership": {
          "question": "Que se passe-t-il quand les dirigeants changent ?",
          "answer": "PAC Hub prend en charge le transfert de responsabilité, les années scolaires archivées et les documents qui survivent aux dirigeants individuels. Les nouveaux dirigeants héritent d'un hub en marche au lieu de connexions dispersées et de fichiers perdus."
        }
      },
      "ctaTitle": "Vous avez encore des questions ?",
      "ctaButton": "Nous joindre"
    },
    "trust": {
      "secure": "Connexion sûre et sécurisée et comptes limités à l'école",
      "noDataSelling": "Les données de votre communauté parentale ne sont pas vendues à des tiers",
      "oneFee": "Un abonnement pour tout votre conseil. Une plateforme avec des outils conçus pour les conseils consultatifs de parents",
      "privacyConsent": "Posture de confidentialité canadienne adaptée aux communautés scolaires",
      "pacControl": "Votre conseil contrôle qui peut accéder aux événements, messages et listes de membres",
      "languages": "Prise en charge multilingue pour votre communauté scolaire"
    },
    "contact": {
      "title": "Contactez-nous",
      "intro": "Intéressé par devenir une école pilote ou pour en savoir plus sur PAC Hub ?",
      "nameLabel": "Nom",
      "namePlaceholder": "Votre nom",
      "emailLabel": "Courriel",
      "emailPlaceholder": "Votre courriel",
      "roleLabel": "Je suis",
      "rolePlaceholder": "Sélectionnez votre rôle",
      "roles": {
        "parent": "Parent",
        "pacExecutive": "Dirigeant du conseil",
        "schoolStaff": "Personnel scolaire",
        "other": "Autre"
      },
      "schoolLabel": "Nom de l'école",
      "schoolPlaceholder": "Votre école (facultatif)",
      "cityLabel": "Ville ou district",
      "cityPlaceholder": "Facultatif",
      "interestLabel": "Je suis intéressé par",
      "interestPlaceholder": "Sélectionnez une option",
      "interests": {
        "pilotSchool": "École pilote",
        "demo": "Démo / Visite guidée",
        "general": "Question générale"
      },
      "messageLabel": "Message",
      "messagePlaceholder": "Parlez-nous de votre conseil et de ce que vous recherchez",
      "marketingConsentLabel": "M'envoyer des mises à jour sur PAC Hub. Je peux se désabonner à tout moment.",
      "privacyDisclosureBefore": "En soumettant ce formulaire, vous acceptez notre",
      "privacyPolicyLink": "Politique de confidentialité",
      "submitButton": "Envoyer le message",
      "successTitle": "Message envoyé",
      "successMessage": "Merci de nous avoir contactés. Nous vous répondrons bientôt.",
      "errorMessage": "Nous n'avons pas pu envoyer votre message. Veuillez réessayer plus tard."
    },
    "contactValidation": {
      "roleRequired": "Veuillez sélectionner votre rôle",
      "interestRequired": "Veuillez sélectionner un intérêt",
      "nameRequired": "Le nom est requis",
      "emailInvalid": "Doit être un courriel valide",
      "messageTooShort": "Le message est trop court",
      "turnstileRequired": "Veuillez compléter la vérification"
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "lastUpdated": "Dernière mise à jour : juin 2026",
      "intro": "Cette politique décrit comment PAC Hub (« nous ») traite les renseignements personnels collectés par l'entremise de pachub.ca avant et pendant notre programme pilote.",
      "whoWeAreTitle": "Qui nous sommes",
      "whoWeAreBody": "PAC Hub fournit des logiciels pour les conseils consultatifs de parents des écoles. Pour les questions ou demandes de confidentialité, contactez-nous à <emailLink>{{email}}</emailLink>.",
      "whatWeCollectTitle": "Ce que nous collectons",
      "whatWeCollectIntro": "Lorsque vous utilisez notre formulaire de contact, nous pouvons collecter :",
      "whatWeCollectItems": {
        "nameEmail": "Nom et adresse courriel",
        "role": "Votre rôle (par exemple, parent, dirigeant du conseil, personnel scolaire)",
        "school": "Nom de l'école et ville ou district, si vous les fournissez",
        "message": "Votre message et l'intérêt indiqué (par exemple, école pilote)",
        "marketingOptIn": "Si vous choisissez de recevoir des mises à jour par courriel sur PAC Hub et les opportunités pilotes"
      },
      "turnstileBodyBefore": "Nous utilisons Cloudflare Turnstile pour réduire le pourriel. Cloudflare peut traiter des données techniques dans le cadre de ce service. Consultez la",
      "turnstileLink": "addendum de confidentialité Turnstile de Cloudflare",
      "turnstileBodyAfter": "pour savoir comment ils traitent ces données.",
      "whyWeCollectTitle": "Pourquoi nous collectons ces données",
      "whyWeCollectItems": {
        "respond": "Pour répondre à votre demande",
        "followUp": "Pour faire suite aux écoles pilotes ou démos que vous demandez (contact lié à la demande)",
        "marketing": "Pour envoyer du courriel promotionnel seulement si vous optez séparément avec la case marketing"
      },
      "noSelling": "Nous ne vendons pas les coordonnées des parents ou du conseil à des tiers.",
      "whereStoredTitle": "Où les données sont stockées",
      "whereStoredBody": "Lorsque vous nous contactez par ce site Web, nous stockons votre soumission dans des systèmes sécurisés utilisés pour exploiter pachub.ca. L'accès est limité aux membres autorisés de l'équipe PAC Hub qui en ont besoin pour répondre aux demandes.",
      "retentionTitle": "Durée de conservation",
      "retentionBody": "Nous conservons les dossiers de contact pendant que votre demande est active et pour une période raisonnable après, ou jusqu'à ce que vous nous demandiez de les supprimer. Les dossiers d'opt-in marketing sont conservés jusqu'à retrait du consentement ou jusqu'à ce que nous n'en ayons plus besoin pour l'objectif indiqué.",
      "choicesTitle": "Vos choix",
      "choicesItems": {
        "access": "Vous pouvez demander l'accès, la correction ou la suppression de vos renseignements en envoyant un courriel à <emailLink>{{email}}</emailLink>",
        "unsubscribe": "Si vous avez opté pour le courriel marketing, vous pouvez se désabonner à tout moment via le lien dans ces messages ou en nous contactant"
      },
      "changesTitle": "Modifications",
      "changesBody": "Nous pouvons mettre à jour cette politique au fil de l'évolution de notre site marketing et de notre produit. La date en haut de cette page indique la dernière révision.",
      "contactLink": "Contactez-nous"
    }
  }
}
